// StateLoader persists redux into localStorage

class StateLoader {

  statePath = "human1:state";

  loadState() {
    try {
      let serializedState = localStorage.getItem(this.statePath);

      if (serializedState === null) {
        return this.initializeState();
      }

      return JSON.parse(serializedState);
    }
    catch (err) {
      return this.initializeState();
    }
  }

  saveState(state) {
    try {
      let serializedState = JSON.stringify(state);
      localStorage.setItem(this.statePath, serializedState);

    }
    catch (err) {
    }
  }

  initializeState() {
    return {
      //state object
    }
  }
}

const stateLoader = new StateLoader()

export default stateLoader



// WEBPACK FOOTER //
// ./src/store/stateLoader.js